.SuggestionsStatusWrapper {
  display: grid;
  place-items: center;
  width: 16px;
  height: 16px;
  border-radius: var(--radius-xs);
}

.SuggestionsStatus {
  width: 16px;
  height: 16px;

  &.success {
    color: var(--primary);
  }

  &.error {
    color: var(--accent-2);
  }

  &.warning {
    color: var(--accent-1);
  }
}
